import React from "react";
import { connect } from "react-redux";

import ApiLogResult from "./ApiLogs/ApiLogResult";
import OutboundResult from "./OutboundLogs/OutboundResult";

import "./logResult.css";
import DraftEditResult from "./DraftEditLogs/DraftEditResult";
import ProcessingResult from "./ProcessingLogs/ProcessingResult";
import SheetLogResult from "./SheetLogs/SheetLogResult";
// import WarmupLogResult from "./WarmupLogs/WarmupLogResult";
import CampaignErrorResult from "./CampaignErrorLogs/CampaignErrorResult";
import ExtensionLogResult from "./ExtensionLogs/ExtensionLogResult";
import StatusResult from "./StatusLogs/StatusResult";
import SmtpLogResult from "./SmtpLogs/SmtpLogResult";
import PushRequestLogResult from "./SmtpPushRequestLogs/PushRequestLogResult";




export class LogResult extends React.Component {

    // constructor(props) {

    // }




    getLogResult = () => {

        switch (this.props.selectedLogType) {
            case 'api':
                return (<ApiLogResult />)
            case 'error':
                return (<CampaignErrorResult />)
            case 'status':
                return (<StatusResult />)
            case 'drafts':
                return (<DraftEditResult />)
            case 'outbound':
                return (<OutboundResult />)
            case 'process':
                return (<ProcessingResult />)
            case 'sheet':
                return (<SheetLogResult />)
            case 'smtp':
                return (<SmtpLogResult />)
            case 'extension':
                    return (<ExtensionLogResult />)
            case 'smtpPush':
                return(<PushRequestLogResult />)
            default:
                return (<div>Unable to render</div>)

        }
    }


    render() {
        return (
            <div className="LogResult">
                {this.getLogResult()}
            </div>


        );
    }
}


const mapStateToProps = (state) => {
    return { selectedLogType: state.logs.selectedLogType };
};

export default connect(mapStateToProps)(LogResult);
